/**
 * The lobby route: `?game=<gameId>`.
 *
 * A router library would be heavier than the problem: there are two
 * screens and the state is one string. But the parameter itself is
 * needed: a link to a demo must open that exact demo (and `npm run shoot`
 * relies on it), and the browser's "back" button must return to the lobby
 * rather than leave the page.
 */

const PARAM = 'game'

export function gameFromUrl(): string | null {
  return new URLSearchParams(window.location.search).get(PARAM)
}

/** Writes the selected game into the URL as a new history entry. null — the lobby. */
export function pushGameUrl(gameId: string | null): void {
  const url = new URL(window.location.href)
  if (gameId) url.searchParams.set(PARAM, gameId)
  else url.searchParams.delete(PARAM)
  if (url.href === window.location.href) return
  window.history.pushState({ [PARAM]: gameId }, '', url)
}

/** Subscription to the browser's "back/forward". */
export function onGameUrlChange(cb: (gameId: string | null) => void): () => void {
  const handler = (): void => cb(gameFromUrl())
  window.addEventListener('popstate', handler)
  return () => window.removeEventListener('popstate', handler)
}
